module.exports = __webpack_public_path__ + "static/media/250218_ff1_lizenz_siegel_single.11b79ca8.svg";